<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="fig"><img alt="Image" src="images/pg7_1.jpg"/></p>
<p class="FMH"><b>Introduction</b></p>
<p class="indent"><i>For as long as I can remember, quilts have been part of my life. As a little girl, I slept under my grandma’s hand-sewn quilts and loved counting the pieces, looking at the beautiful prints, and running my fingers over the stitches that held everything together. When I grew up and had a family of my own, on a whim, I set about teaching myself how to sew a quilt, and I fell in love with them all over again.</i></p>
<p class="indenti"><i>Since there are only so many beds in need of quilts, and there are so many designs just waiting to be made, I began stitching my quilts in smaller and smaller sizes, and “whatnots” were born! These little quilts can be tucked into the smallest niches, nestled onto tabletops, rolled into crocks or baskets, racked and stacked, or displayed on your walls.</i></p>
<p class="indenti"><i>In addition to being versatile, small whatnots can bring big opportunities. You can treat them as skill builders and dabble in new techniques, or even stretch yourself and tackle more advanced block designs, knowing that the finish line is in sight right from the very start. Best of all, unlike large quilts, with no long-term commitment needed you can be fickle and jump from project to project with a completely clear conscience. No judging happening here!</i></p>
<p class="indenti"><i>In this fourth installment of my Simple Whatnots series, I’ve included many of my personal favorite designs in the hopes of serving up a truly scrumptious midnight snack of mini quilts. And to further sweeten the “Diehl,” of the nineteen quilts included in this collection, six projects are brand new and designed just for you.</i></p>
<p class="indenti"><i>Gather your favorite scraps and prints, rev up your sewing machine, and stitch to your heart’s content!</i></p>
<p class="right1"><i>~ Kim</i></p>
<p class="fig"><img alt="Image" src="images/pg8_1.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_intro.vue?74b429e0